import { createFileRoute } from '@tanstack/react-router';
import { PerksPage } from '~/components/pages/PerksPage';
import { pageHeadMeta } from '~/lib/seo';
import perksStylesHref from '~/styles/perks.css?url';

export const Route = createFileRoute('/perks')({
  head: () =>
    pageHeadMeta({
      title: 'Perks — nsave',
      description:
        'Save with our global network. The nsave app comes with exclusive deals and offers from our partner network, all under Benefits.',
      path: '/perks',
      stylesheets: [perksStylesHref],
    }),
  component: PerksPage,
});
